import { getApp, getHostHub, isHostedCalendar } from 'owa-config';
import { isBootFeatureEnabled } from 'owa-metatags';

/**
 * Get User Agent string for presence service calls
 * Each app with its own app ID should also have a distinct user agent string. 'Places' and 'Calendar in Teams' have separate app IDs, while all other modules use the Outlook app ID.
 * Possible return values are 'Places', 'Outlook', 'Calendar'
 */
export const getUserAgent = (): 'Places' | 'Outlook' | 'Calendar' => {
    const app = getApp();
    if (app === 'Places') {
        return 'Places';
    }
    return isHostedCalendarApp() ? 'Calendar' : 'Outlook';
};

export const isHostedCalendarApp = (): boolean => {
    const hostClientType = getHostHub();
    if (!hostClientType) {
        return false;
    }
    return (
        isBootFeatureEnabled('auth-msaljs-hostedcalendar-i2') &&
        isHostedCalendar() &&
        (hostClientType === 'teamshub' || hostClientType === 'officeweb')
    );
};
